<script setup lang="ts">
defineProps<{
  shopTheLook: unknown
  lazy: boolean
  size: 'small' | 'medium' | 'large'
}>()
</script>

<template>
  <article
    v-if="shopTheLook"
    class="shop-the-look-tile"
    :class="`shop-the-look-tile--${size}`"
  >
    <h3 class="shop-the-look-tile__heading">
      {{ shopTheLook?.Title }}
    </h3>

    <div
      class="shop-the-look-tile__visual"
    >
      <picture v-if="size === 'large' && shopTheLook?.ImageHero?.url && shopTheLook?.ImageTile?.url">
        <source
          :srcset="useXcdnImage(shopTheLook.ImageHero.url, 'f=rs:fit:1440')"
          media="(min-width: 1280px)"
        >
        <source
          :srcset="useXcdnImage(shopTheLook.ImageHero.url, 'f=rs:fit:1280')"
          media="(min-width: 1024px)"
        >
        <source
          :srcset="useXcdnImage(shopTheLook.ImageHero.url, 'f=rs:fit:1024')"
          media="(min-width: 768px)"
        >
        <source :srcset="useXcdnImage(shopTheLook.ImageTile.url, 'f=rs:fit:768')">
        <img
          class="shop-the-look-tile__image"
          :src="useXcdnImage(shopTheLook.ImageTile.url, 'f=rs:fit:768')"
          :alt="shopTheLook.ImageTile.alternativeText || shopTheLook.Title || ''"
          :width="shopTheLook.ImageTile.width"
          :height="shopTheLook.ImageTile.height"
          :loading="lazy ? 'lazy' : 'eager'"
          :fetchpriority="lazy ? 'low' : 'high'"
          :decoding="lazy ? 'async' : 'sync'"
        >
      </picture>
      <picture v-else-if="shopTheLook?.ImageTile?.url">
        <img
          class="shop-the-look-tile__image"
          :src="useXcdnImage(shopTheLook.ImageTile.url, 'f=rs:fit:768')"
          :alt="shopTheLook.ImageTile.alternativeText || shopTheLook.Title || ''"
          :width="shopTheLook.ImageTile.width"
          :height="shopTheLook.ImageTile.height"
          :loading="lazy ? 'lazy' : 'eager'"
          :fetchpriority="lazy ? 'low' : 'high'"
          :decoding="lazy ? 'async' : 'sync'"
        >
      </picture>

      <div
        v-if="shopTheLook?.Products?.length"
        class="shop-the-look-tile__products"
      >
        <ShopTheLookProduct
          v-for="product in shopTheLook.Products"
          :key="product"
          class="shop-the-look-tile__product"
          :product="product?.product"
        />
      </div>
    </div>
  </article>
</template>

<style>
@import url("~layers/app/components/ShopTheLook/Tile.css");
</style>
